/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SignatureAuthority } from './SignatureAuthority';
import {
    SignatureAuthorityFromJSON,
    SignatureAuthorityFromJSONTyped,
    SignatureAuthorityToJSON,
    SignatureAuthorityToJSONTyped,
} from './SignatureAuthority';

/**
 * 
 * @export
 * @interface SafeDepositBoxServiceRoleProperties
 */
export interface SafeDepositBoxServiceRoleProperties {
    /**
     * 
     * @type {string}
     * @memberof SafeDepositBoxServiceRoleProperties
     */
    propertiesType: string;
    /**
     * Type of Safe Role
     * @type {string}
     * @memberof SafeDepositBoxServiceRoleProperties
     */
    safeRole: string;
    /**
     * 
     * @type {SignatureAuthority}
     * @memberof SafeDepositBoxServiceRoleProperties
     */
    signatureAuthority: SignatureAuthority;
}



/**
 * Check if a given object implements the SafeDepositBoxServiceRoleProperties interface.
 */
export function instanceOfSafeDepositBoxServiceRoleProperties(value: object): value is SafeDepositBoxServiceRoleProperties {
    if (!('propertiesType' in value) || value['propertiesType'] === undefined) return false;
    if (!('safeRole' in value) || value['safeRole'] === undefined) return false;
    if (!('signatureAuthority' in value) || value['signatureAuthority'] === undefined) return false;
    return true;
}

export function SafeDepositBoxServiceRolePropertiesFromJSON(json: any): SafeDepositBoxServiceRoleProperties {
    return SafeDepositBoxServiceRolePropertiesFromJSONTyped(json, false);
}

export function SafeDepositBoxServiceRolePropertiesFromJSONTyped(json: any, ignoreDiscriminator: boolean): SafeDepositBoxServiceRoleProperties {
    if (json == null) {
        return json;
    }
    return {
        
        'propertiesType': json['propertiesType'],
        'safeRole': json['safeRole'],
        'signatureAuthority': SignatureAuthorityFromJSON(json['signatureAuthority']),
    };
}

export function SafeDepositBoxServiceRolePropertiesToJSON(json: any): SafeDepositBoxServiceRoleProperties {
    return SafeDepositBoxServiceRolePropertiesToJSONTyped(json, false);
}

export function SafeDepositBoxServiceRolePropertiesToJSONTyped(value?: SafeDepositBoxServiceRoleProperties | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'propertiesType': value['propertiesType'],
        'safeRole': value['safeRole'],
        'signatureAuthority': SignatureAuthorityToJSON(value['signatureAuthority']),
    };
}

